<template>
  <v-container fluid>
    <v-row justify="space-around">
      <v-col md="3" cols="12">
        <v-card
          rounded="5"
          class="pa-1 m-1"
          theme="dark"
          height="250"
        >
          <v-card-text>
            <div>Word of the Day</div>
            <p class="text-h4 text--primary">
              el·ee·mos·y·nar·y
            </p>
            <p>adjective</p>
            <div class="text--primary">
              relating to or dependent on charity; charitable.<br>
              "an eleemosynary educational institution."
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              variant="text"
              color="teal-accent-4"
            >
              Learn More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="3" cols="12">
        <v-card
          rounded="5"
          class="pa-1 m-1"
          theme="dark"
          height="250"
        >
          <v-card-text>
            <div>Word of the Day</div>
            <p class="text-h4 text--primary">
              el·ee·mos·y·nar·y
            </p>
            <p>adjective</p>
            <div class="text--primary">
              relating to or dependent on charity; charitable.<br>
              "an eleemosynary educational institution."
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              variant="text"
              color="teal-accent-4"
            >
              Learn More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="6" cols="12">
        <v-card
          rounded="5"
          class="pa-1 m-1"
          theme="dark"
          height="250"
        >
          <v-card-text>
            <div>Word of the Day</div>
            <p class="text-h4 text--primary">
              el·ee·mos·y·nar·y
            </p>
            <p>adjective</p>
            <div class="text--primary">
              relating to or dependent on charity; charitable.<br>
              "an eleemosynary educational institution."
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              variant="text"
              color="teal-accent-4"
            >
              Learn More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="9" cols="12">
        <v-card
          rounded="5"
          class="pa-1 m-1"
          theme="dark"
          height="300"
        >
          <v-card-text>
            <div>Word of the Day</div>
            <p class="text-h4 text--primary">
              el·ee·mos·y·nar·y
            </p>
            <p>adjective</p>
            <div class="text--primary">
              relating to or dependent on charity; charitable.<br>
              "an eleemosynary educational institution."
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              variant="text"
              color="teal-accent-4"
            >
              Learn More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="3" cols="12">
        <v-card
          rounded="5"
          class="pa-1 m-1"
          theme="dark"
          height="300"
        >
          <v-card-text>
            <div>Word of the Day</div>
            <p class="text-h4 text--primary">
              el·ee·mos·y·nar·y
            </p>
            <p>adjective</p>
            <div class="text--primary">
              relating to or dependent on charity; charitable.<br>
              "an eleemosynary educational institution."
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              variant="text"
              color="teal-accent-4"
            >
              Learn More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
